import mutations from './mutations'

const initialState = {
  company: 'table',
  contact: 'table',
  occupier: 'table',
  property: 'table',
  availability: 'propertyType',
  comparable: 'table',
  project: 'table',
  pipeline: 'table',
  deal: 'table',
  requirement: 'table',
}

export default {
  namespaced: true,
  state: initialState,
  mutations,
}
